/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from 'react'
import { Link, useParams, useHistory } from 'react-router-dom'
import {
  format,
  startOfWeek,
  endOfWeek,
  subWeeks,
  addWeeks,
  addDays,
} from 'date-fns'
import { useNotification } from 'src/contexts/notification.context'
import { useAuth } from 'src/contexts/auth.context'
import { getTeacherEvents, getStudentEvents } from 'src/services/api.service'
import { routes } from 'src/navigation/routes'
import { times } from 'src/tools'

export const Schedule = () => {
  const { user } = useAuth()
  const history = useHistory()
  const { date = null } = useParams()
  const { wrapCallback } = useNotification()
  const [startDay, setStartDay] = useState(
    startOfWeek(date ? new Date(date) : new Date()),
  )
  const [endDay, setEndDay] = useState(
    endOfWeek(date ? new Date(date) : new Date()),
  )
  const [data, setData] = useState({})
  const [curDate, setCurDate] = useState(date)

  useEffect(() => {
    if (Object.keys(data).length === 0) {
      const first = startOfWeek(date ? new Date(date) : new Date())
      const days = times(7).reduce((acc, val) => {
        acc[format(addDays(first, val), 'yyyy-MM-dd')] = []
        return acc
      }, {})
      setData(days)
    }
  }, [data])

  useEffect(() => {
    if (!date) {
      history.push(routes.timetable.day(format(new Date(), 'yyyy-MM-dd')))
      return
    }
    setCurDate(date)
  }, [date])

  useEffect(() => {
    wrapCallback(async () => {
      console.log(user)
      if (!user.role_id) return

      const getEvents = user.role_id === 1 ? getTeacherEvents : getStudentEvents

      const response = await getEvents({
        start_date: format(startDay, 'yyyy-MM-dd'),
        end_date: format(endDay, 'yyyy-MM-dd'),
      })
      setData(response.data?.items)
    })
  }, [startDay, endDay])

  const handleChangeCurDate = (val) => () => {
    // setCurDate(val);
    history.push(routes.timetable.day(val))
  }

  const handleLeftWeek = () => {
    setStartDay(addWeeks(startDay, 1))
    setEndDay(addWeeks(endDay, 1))
  }

  const handleRightWeek = () => {
    setStartDay(subWeeks(startDay, 1))
    setEndDay(subWeeks(endDay, 1))
  }

  const labelDate =
    !date || date === format(new Date(), 'yyyy-MM-dd')
      ? 'Today'
      : format(new Date(date), 'MMM dd')

  return (
    <>
      <div className="sectionHb-top">
        <h2 className="sectionHb-title">Schedule</h2>
        <span className="sectionHb-sub">{labelDate}</span>
      </div>

      <div className="dateBoard">
        <div className="dateBoard-head">
          <div className="dateBoard-head__wrap">
            <div className="dateBoard-slider swiper-container swiper-container-initialized swiper-container-horizontal">
              <div
                className="dateBoard-slider__wrapper swiper-wrapper"
                id="swiper-wrapper-bbe4076749bda4710"
                aria-live="polite"
              >
                {data &&
                  Object.keys(data).map((x) => (
                    <div
                      key={x}
                      className={`dateBoard-slide swiper-slide swiper-slide-visible ${
                        curDate === x ? 'swiper-slide-active' : ''
                      }`}
                      role="group"
                      aria-label="1 / 7"
                      onClick={handleChangeCurDate(x)}
                    >
                      <div className="dateBoard-wrap">
                        {/* <i class="hb-ico dateBoard-ico-1"></i> */}
                        <div className="dateBoard-info">
                          {}
                          <span>{format(new Date(x), 'MMM')}</span>
                          <b>{format(new Date(x), 'dd')}</b>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <span
                className="swiper-notification"
                aria-live="assertive"
                aria-atomic="true"
              />
            </div>
            <div
              onClick={handleLeftWeek}
              className="swiper-button-next"
              tabIndex="0"
              role="button"
              aria-label="Next slide"
              aria-controls="swiper-wrapper-bbe4076749bda4710"
              aria-disabled="false"
            />
            <div
              onClick={handleRightWeek}
              className="swiper-button-prev"
              tabIndex="-1"
              role="button"
              aria-label="Previous slide"
              aria-controls="swiper-wrapper-bbe4076749bda4710"
              aria-disabled="true"
            />
          </div>
        </div>
      </div>

      <div className="sectionHb-block schedule">
        <div className="sectionHb-block__wrap">
          <div className="row">
            <div className="col-lg-3 col-sm-6 col-12" />
            <div className="col-lg-3 col-sm-6 col-12" />
            <div className="col-lg-3 col-sm-6 col-12" />
            <div className="col-lg-3 col-sm-6 col-12">
              <div className="input-block">
                <Link
                  to={routes.timetable.new(curDate)}
                  className="primary-btn primary-btn__big"
                >
                  <i className="hb-ico plus-ico-white" />
                  Event
                </Link>
              </div>
            </div>
          </div>

          <div className="schedule-content">
            {Array.isArray(data[curDate]?.events) ? (
              data[curDate]?.events?.map((x) => (
                <div key={x.id} className="schedule-item schedule-gray">
                  <div className="schedule-main">
                    <div className="tooltip">
                      <i className="hb-ico check-done" />
                      <div className="tooltip-info">Done</div>
                    </div>
                    <b>Math</b>
                    <span>
                      {format(
                        new Date(`${x.start_date} ${x.start_time} `),
                        'h:mm aa',
                      )}
                    </span>
                  </div>
                  <div className={`schedule-info bg-${x.color}`}>
                    {x.priority && (
                      <div className="tooltip">
                        <i className={`hb-ico hb-ico-24 ico-${x.priority}`} />
                        <div className="tooltip-info">
                          <span>Description</span>
                        </div>
                      </div>
                    )}
                    {Number(x.created_by_id) === Number(user.id) ? (
                      <Link
                        to={routes.timetable.edit(x.id)}
                        class="schedule-name"
                      >
                        {x.title}
                      </Link>
                    ) : (
                      <div
                        to={routes.timetable.edit(x.id)}
                        className="schedule-name"
                      >
                        {x.title}
                      </div>
                    )}
                    <p>{x.content}</p>
                  </div>
                </div>
              ))
            ) : (
              <div className="label-none">No events for this day</div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
